import { BrandMark } from "./BrandMark.js";
import { Icon } from "./Icon.js";
import { useTheme } from "../lib/theme.js";

export const AuthFrame = ({
  eyebrow,
  title,
  description,
  children,
}: {
  readonly eyebrow: string;
  readonly title: string;
  readonly description: string;
  readonly children: React.ReactNode;
}): React.JSX.Element => {
  const theme = useTheme();

  return (
    <main className="auth-frame">
      <section className="auth-story" aria-label="Vakilat trust statement">
        <div className="flex items-center gap-3">
          <BrandMark />
          <span className="font-display text-xl">Vakilat</span>
        </div>
        <div className="max-w-lg">
          <p className="eyebrow">AI-assisted, advocate-verified</p>
          <h1 className="font-display mt-4 text-4xl leading-tight sm:text-5xl">
            Legal work that shows its sources.
          </h1>
          <p className="mt-5 max-w-md text-base leading-7 text-[var(--muted)]">
            Research Indian law, draft from real authority, and inspect every step
            before anything leaves your practice.
          </p>
        </div>
        <p className="text-sm text-[var(--dim)]">Processed in India</p>
      </section>

      <section className="auth-panel">
        <button
          type="button"
          onClick={theme.toggle}
          className="icon-button absolute top-5 right-5"
          aria-label={`Use ${theme.mode === "dark" ? "light" : "dark"} theme`}
        >
          <Icon name={theme.mode === "dark" ? "sun" : "moon"} size={17} />
        </button>
        <div className="w-full max-w-md">
          <p className="eyebrow">{eyebrow}</p>
          <h2 className="font-display mt-3 text-3xl">{title}</h2>
          <p className="mt-2 text-sm leading-6 text-[var(--muted)]">{description}</p>
          <div className="mt-8">{children}</div>
        </div>
      </section>
    </main>
  );
};
